import React from "react";
import { Theme } from "../../../../providers/ThemeProvider";
import useTheme from "../../../../common/hooks/useTheme";

/**
 * Placeholder for a History tab whose backend does not exist yet.
 *
 * Deliberately a sibling of `seviceBuilder/EmptyScreen` rather than a fourth
 * variant of it: that component's copy table is service/logic/lab specific and
 * it always renders a primary button, and there is nothing here for the user to
 * do — the data simply isn't available yet. Card and typography match it so the
 * two read as the same family.
 */
type Props = {
  title: string;
  text: string;
};

const HistoryNotReadyState = ({ title, text }: Props) => {
  const theme: Theme = useTheme();

  return (
    <div style={styles.cardContainer(theme)}>
      <div style={styles.cardTitle(theme)}>{title}</div>
      <div style={styles.cardText(theme)}>{text}</div>
    </div>
  );
};

export default HistoryNotReadyState;

const styles = {
  cardContainer: (theme: Theme) => ({
    backgroundColor: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    borderRadius: "8px",
    padding: "32px",
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center" as "center",
  }),
  cardTitle: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "18px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    marginBottom: "8px",
  }),
  cardText: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "16px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    maxWidth: "560px",
  }),
};
